export const FORM_FIELD_KEYS = {
	REQUEST_STATUS: 'requestStatus',
	DATE_RANGE: 'dateRange'
};

export type TRefundRequestFilters = {
	requestStatus: string;
	startTime?: number;
	endTime?: number;
};

export type TDownloadRefundsFilter = {
	startTime?: number;
	endTime?: number;
};

export interface IApproveAndRefundRequestInBulk {
	refundReqIdList: string[];
	isRejected: boolean;
}

export type ContentPropsT = {
	handleFilterSubmit: (submittedFilters: any) => void;
	onClose: () => void;
};

export enum REQUEST_STATUS {
	PENDING = 'pending',
	APPROVED = 'approved',
	REJECTED = 'rejected'
}

export enum REFUND_STATUS {
	SUCCESS = 'success',
	PENDING = 'pending',
	REJECTED = 'rejected'
}

export const REQUEST_STATUS_OPTIONS = [
	{ id: 'pending', label: 'PENDING' },
	{ id: 'approved', label: 'APPROVED' },
	{ id: 'rejected', label: 'REJECTED' }
];

export const PAGE_LIMIT: number = 500;
